export const LANGUAGE_CHOICES = [
  'en', 'en-US', 'en-GB', 'en-CA', 'en-AU', 'en-IE', 'en-NZ', 'en-ZA',
  'fr', 'fr-FR', 'fr-CA', 'fr-BE', 'fr-CH', 'fr-LU',
  'es', 'es-ES', 'es-MX', 'es-419', 'es-US',
  'de', 'de-DE', 'de-AT', 'de-CH',
  'it', 'it-IT', 'it-CH',
  'nl', 'nl-NL', 'nl-BE',
  'pt', 'pt-PT', 'pt-BR',
  'pl', 'cs', 'sk', 'hu', 'ro', 'bg', 'hr', 'sl', 'sr', 'el',
  'da', 'sv', 'nb', 'fi', 'et', 'lv', 'lt',
  'tr', 'ru', 'uk', 'ar', 'he',
  'zh', 'zh-CN', 'zh-TW', 'ja', 'ko', 'th', 'vi', 'id', 'ms', 'hi',
];
